/**
 * Master Fortune page — English (nested for t('masterFortune.…'))
 */
export default {
	meta: {
		title: "1,000+ Global Experts at Your Service",
		keywords: "BaZi reading,live fortune telling,spiritual consultation",
		description:
			"SeerQ is a professional live fortune-telling platform offering authoritative, precise readings. From BaZi analysis and career/wealth forecasts to love and marriage guidance — all delivered one-on-one by experienced mentors online.",
	},
	pageHeader: {
		breadcrumbHome: "Home",
		breadcrumbCurrent: "More Mentors",
		searchPlaceholder: "Search by mentor or creator name",
		searchButton: "Search",
	},
	index: {
		subBanner: {
			title: "Over a Million Authentic Readings",
			subtitle: "Real reputation, trusted service",
			defaultUserName: "Chen***",
			starRatingAria: "Rating: {score} stars",
			starAlt: "Star",
			emptyStarAlt: "Empty star",
		},
		tags: [
			{ title: "2M+", desc: "Core Users" },
			{ title: "99%+", desc: "Satisfaction Rate" },
			{ title: "4.96/5", desc: "Client Rating" },
			{ title: "200+", desc: "Certified Mentors Worldwide" },
		],
	},
	teacherResource: {
		ariaLabel: "Recommended Mentors",
		title: "Recommended Mentors",
		loading: "Loading...",
		empty: "No recommended mentors yet",
		prevNav: "Previous mentors",
		nextNav: "Next mentors",
		dotsAria: "Mentor list pagination",
		pageAria: "Page {index}",
		avatarAlt: "Mentor avatar",
		chatAria: "Consult Now",
		defaultName: "Mentor",
		defaultSummary: "All-round mentor with 99% client satisfaction",
		defaultTags: ["Love & Relationships", "Marriage Recovery"],
		viewDetail: "View Profile",
		consultNow: "Consult Now",
	},
	teacherRecommend: {
		ariaLabel: "Popular Mentors",
		title: "Popular Mentors",
		viewDetail: "View Details",
		consultNow: "Consult Now",
		consultTeacher: "Consult Mentor",
		loadMore: "Load More >",
		priceFrom: "from",
		consultCount: "{count} consults",
		sortOptions: {
			order_count: "Sort by Popularity",
			buy_total: "Sort by Trending",
		},
		sortOptionsMobile: {
			order_count: "Popularity",
			buy_total: "Trending",
		},
		themeOptions: {
			1: "All Topics",
			2: "Decision-Making & Questions",
			3: "Family & Health",
			4: "Career & Wealth",
			5: "Love & Relationships",
		},
	},
};
